<!--Shared email modal -->
<app-email-modal></app-email-modal>
<!-- Scheduled activity modal -->
<ng-container>
    <app-scheduled-activity-modal></app-scheduled-activity-modal>
</ng-container>
